import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from 'measures/responsive'
import { printCSS } from '@utils/style'

interface CatchwordPros {
  catchword?: string
}

const CatchwordWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

const StyledCatchword = styled.span`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        brandColors: { brand_55 },
      },
    },
  }) => css`
    flex-grow: 1;
    font-family: ${goodOT};
    font-size: 26px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: 0;
    margin: 0;
    color: ${brand_55};
    display: block;

    ${mobileCSS(css`
      font-size: 5vw;
    `)}
    ${printCSS(css`
      font-size: 17px;
      line-height: 150%;
    `)}
  `}
`

const Catchword: FunctionComponent<CatchwordPros> = ({ catchword }) => {
  return catchword ? (
    <CatchwordWrapper>
      <StyledCatchword>{catchword}</StyledCatchword>
    </CatchwordWrapper>
  ) : null
}

export default Catchword
